import React from 'react'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal,
    PopoverBody,
    UncontrolledPopover
} from "reactstrap";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../translations/alert_translations";
import {common_strings} from "../translations/common_translations";
import {resource_strings} from "../translations/resource_translations";
import localeHelpers from "../helpers/LocaleHelper";
import PPTableRow from "./Tables/PPTableRow";
import businessApiService from "../api/business-api-service";
import CancPolicyView from "./Resources/CancPolicyView";
import NewsView from "./Resources/NewsView";
import TicketTypeApiService from "../api/tt-api-service";
import StripeSetupView from "./Resources/StripeSetupView";
import ReactTooltip from "react-tooltip";
import RequiredFieldsView from "./Resources/RequiredFieldsView";
import ReportsHeader from "./Headers/ReportsHeader";
import businessHelper from "../helpers/BusinessHelper";
import storage from "../Firebase";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const propTypes = {};

export default class PublicProfile extends React.Component {

    constructor(props) {
        super(props);

        this.fileRef = React.createRef();

        this.state = {
            pp: this.props.pp,
            isLoading: false,
            showCPModal: false,
            showAdModal: false,
            showSModal: false,
            ticketTypes: null,
            showReqFieldsModal: false,
            business: businessHelper.business(),
            goToS: false,
        };
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.pp && (JSON.stringify(nextProps.pp) != JSON.stringify(this.state.pp))) {
            this.setState({pp: nextProps.pp})
        }
    }

    closeCPView = this.closeCPView.bind(this);
    closeReqFieldsView = this.closeReqFieldsView.bind(this);
    handleNetworkError = this.handleNetworkError.bind(this);
    deleteBackgroundPhoto = this.deleteBackgroundPhoto.bind(this);
    deleteBackground = this.deleteBackground.bind(this);
    deleteLogo = this.deleteLogo.bind(this);
    getUser = this.getUser.bind(this);

    renderTable() {
        return this.generatePpData().filter((value, index, self) => index === self.findIndex((t) => (
            t.name === value.name
        ))).map((item, index) => {
            return (<PPTableRow ppItem={item}
                                key={index + item.name.length + item.description.length + Math.floor(Math.random() * (1100)) + 1}/>)
        })
    };

    componentDidMount() {
        this.getPP()
    }

    onChangeFile(event) {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        console.log(file);
        this.setState({file}); /// if you want to upload latter
        this.uploadBackgroundPhoto(file);
    }

    deleteBackgroundPhoto() {
        this.setState({
            isLoading: true,
        });

        const businessId = businessHelper.business().id;

        const deleteRef = storage.ref(`backgrounds/${businessId}/user_photo${this.state.business.id}`);

        // Delete the file
        deleteRef.delete().then(() => {
        }).catch((error) => {
        });

        const deleteRef2 = storage.ref(`backgrounds/${businessId}/user_photo_${this.state.business.id}`);
        deleteRef2.delete().then(() => {

        }).catch((error) => {
        });

        this.updateBusinessPhoto("");

    };

    uploadBackgroundPhoto(file) {
        if (!file) return;

        this.setState({
            isLoading: true,
        });
        const businessId = businessHelper.business().id;
        const uploadTask = storage.ref(`backgrounds/${businessId}/user_photo_${this.state.business.id}`).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                this.setState({
                    isLoading: false,
                });
                this.handleNetworkError(error);
                console.log(error);
            },
            () => {
                storage
                    .ref(`backgrounds/${businessId}`)
                    .child(`user_photo_${this.state.business.id}`)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({url});
                        this.updateBusinessPhoto(url);
                    });
            }
        );
    };

    uploadFile(file) {
        if (!file) return;

        this.setState({
            isLoading: true,
        });

        const businessId = businessHelper.business().id;
        const uploadTask = storage.ref(`logos/${businessId}/user_logo_${this.state.business.id}`).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                this.setState({
                    isLoading: false,
                });
                this.handleNetworkError(error);
                console.log(error);
            },
            () => {
                storage
                    .ref(`logos/${businessId}`)
                    .child(`user_logo_${this.state.business.id}`)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({url});
                        this.state.uploadingLogo ? this.updateBusinessLogo(url) : this.updateBusinessPhoto(url);
                    });
            }
        );
    };

    updateBusinessPhoto(url) {
        this.setState({isLoading: true});
        businessApiService.update({photo: url})
            .then(res => {
                this.setState({isLoading: false, scrollToTop: true});
                this.getUser();
            })
            .catch((e) => {
                this.setState({isLoading: false});
                this.handleNetworkError(e)
            });
    }

    getUser() {
        businessApiService.current()
            .then(res => {
                businessHelper.saveUserSession(res);
                this.setState({
                    business: res.user,
                    address: res.address,
                    locales: res.locales,
                    isLoading: false
                });

                this.getPP();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    render() {
        this.localize();

        if (this.state.goToS === true) {
            window.location.replace(`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_FVVYQ2LLjNcHkpAX2boYnb7ChHJDTXGp&scope=read_write&&redirect_uri=https://www.openmanagerapp.com/admin/user-profile`);
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <Card className="bg-secondary shadow">

                    <input type="file" id="file" ref={this.fileRef} style={{display: "none"}}
                           onChange={this.onChangeFile.bind(this)}/>

                    <ReportsHeader photo={this.state.pp ? this.state.pp.photo : null}/>

                    {this.state.showCPModal &&
                        this.renderCPModal()
                    }

                    {this.state.showReqFieldsModal &&
                        this.renderReqFieldsModal()
                    }

                    {this.state.showAdModal &&
                        this.renderAdModal()
                    }

                    {this.state.showSModal &&
                        <StripeSetupView ticketTypes={this.state.ticketTypes} sId={this.state.pp.stripe_id}
                                         goToStripe={this.goToStripe.bind(this)}
                                         toggle={this.toggleStripeModal.bind(this)}
                                         disconnectStripe={this.disconnectStripe.bind(this)}
                        />
                    }
                    {this.state.pp &&
                        <>
                            <CardHeader className="bg-white border-0">
                                <ReactTooltip/>
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                                    <h3 className="mb-0">{resourceStrings.public_profile.public_profile}
                                        <i className="fas fa-info-circle ml-1 text-gray"
                                           id="info_popover"
                                        />
                                        <UncontrolledPopover placement="top" target="info_popover">
                                            <PopoverBody>
                                                {commonStrings.tutorial.pp.body_1}
                                            </PopoverBody>
                                        </UncontrolledPopover>
                                    </h3>

                                    <div style={{marginLeft: 20, paddingTop: 5}}
                                         data-tip={resourceStrings.public_profile.public_switch_expl}
                                         data-type="error"
                                    >
                                        <label className="custom-toggle"
                                               style={{margin: 0}}>
                                            <input type="checkbox"
                                                   color="success"
                                                   disabled={!this.readyToGoPublic()}
                                                   onChange={this.setPublic.bind(this)}
                                                   checked={this.state.pp.public && this.readyToGoPublic()}
                                                   id="public-slider"/>
                                            <span className="custom-toggle-slider rounded-circle"/>
                                        </label>
                                    </div>
                                    {/*<Col lg="1" className="align-content-center">*/}

                                    {/*</Col>*/}
                                    <Col className="text-right" xs="4">
                                        {this.state.profileWasUpdated &&
                                            <Button
                                                color="default"
                                                onClick={e => this.handleSubmit(e)}
                                                size="sm"
                                            >
                                                {commonStrings.save}
                                            </Button>
                                        }
                                    </Col>
                                </div>
                            </CardHeader>
                            <CardBody>

                                {this.state.pp.deeplink &&
                                    <FormGroup className="mb-0">
                                        <label
                                            className="form-control-label"
                                        >
                                            <small
                                                className="text-muted ml-2 font-weight-bold">{resourceStrings.deeplink_expl}</small>
                                        </label>
                                        <InputGroup className="input-group-alternative">
                                            <Input
                                                id="deeplink_input"
                                                value={this.state.pp.deeplink}
                                                readOnly={true}
                                                type="url"/>

                                            <InputGroupAddon addonType="append">
                                                <InputGroupText>
                                                    <Button size={"sm"} onClick={e => this.copyDeeplink()}>
                                                        <i className="fas fa-copy text-success"/>
                                                    </Button>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </FormGroup>
                                }

                                <div style={{marginTop: 30, marginBottom: 30}}>
                                    <div>
                                        <label>{resourceStrings.download_badge}</label>
                                    </div>
                                    <a
                                        href={this.clientAppBadgeDownloadLink()}
                                        download
                                        onClick={e => this.download(e)}
                                    >
                                        <img
                                            alt="client app badge"
                                            height={240}
                                            style={{marginRight: 30, marginBottom: 20}}
                                            src={this.clientAppLocalizedBadge()}
                                        />
                                    </a>

                                    <a
                                        href={this.clientAppBadgeDownloadLinkDark()}
                                        download
                                        onClick={e => this.download(e)}
                                    >

                                        <img
                                            alt="client app badge"
                                            height={240}
                                            src={this.clientAppLocalizedBadgeDark()}
                                        />
                                    </a>
                                </div>

                                {this.renderTable()}
                            </CardBody>
                        </>
                    }
                </Card>
            </LoadingOverlay>
        )
    }

    clientAppLocalizedBadge() {
        switch (localeHelpers.currentLocale()) {
            case "es":
                return require("assets/img/client_app_badge/OPEN_Client_download_es.png");
            case "ru":
                return require("assets/img/client_app_badge/OPEN_Client_download_ru.png");
            default:
                return require("assets/img/client_app_badge/OPEN_Client_download_eng.png");
        }
    }

    clientAppLocalizedBadgeDark() {
        switch (localeHelpers.currentLocale()) {
            case "es":
                return require("assets/img/client_app_badge/OPEN_Client_download_es_dark.png");
            case "ru":
                return require("assets/img/client_app_badge/OPEN_Client_download_ru_dark.png");
            default:
                return require("assets/img/client_app_badge/OPEN_Client_download_eng_dark.png");
        }
    }

    download = e => {
        console.log(e.target.href);
        fetch(e.target.href, {
            method: "GET",
            headers: {}
        })
            .then(response => {
                response.arrayBuffer().then(function (buffer) {
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "open_client.png"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            })
            .catch(err => {
                console.log(err);
            });
    };

    localize() {
        const loc = localeHelpers.currentLocale();

        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    backgroundPicker(e) {
        this.setState({uploadingLogo: false, uploadingBack: true});
        this.fileRef.current.click();
    }

    generatePpData() {
        const data = this.state.pp ? [
            {
                name: `📝 ${commonStrings.description}`,
                required: commonStrings.required,
                description: commonStrings.business.business_description_hint + " " + resourceStrings.public_profile.description_hint,
                done: !!(this.state.pp.description && this.state.pp.description.length > 10),
                action: this.editDescriptionAction.bind(this)
            },
            {
                name: `🎴 ${resourceStrings.logo}`,
                required: commonStrings.required,
                description: resourceStrings.public_profile.logo_hint,
                done: !!(this.state.pp.logo && this.state.pp.logo.length > 10),
                action: this.editDescriptionAction.bind(this),
                imageUrl: this.state.pp.logo ? this.state.pp.logo : null,
                deleteAction: this.deleteLogo
            },
            {
                name: `📍 ${commonStrings.address}`,
                required: commonStrings.required,
                description: resourceStrings.public_profile.address_hint,
                done: !!(this.state.pp.address && this.state.pp.address.length > 5),
                action: this.editDescriptionAction.bind(this)
            },
            {
                name: `❌ ${resourceStrings.public_profile.canc_policy}`,
                required: commonStrings.required,
                description: resourceStrings.public_profile.canc_policy_hint,
                done: true,
                action: this.showCPEditor.bind(this)
            },
            {
                name: `💳 ${resourceStrings.public_profile.online_payments}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.online_payments_expl,
                done: true,
                action: this.showStripeModal.bind(this)
            },
            {
                name: `📧 ${resourceStrings.public_profile.email_verified}`,
                required: commonStrings.required,
                description: this.state.pp.verified ? resourceStrings.public_profile.email_is_verified : resourceStrings.public_profile.email_not_verified,
                done: this.state.pp.verified,
                action: this.sendVerificationLink.bind(this)
            },
            {
                name: `🏞️ ${resourceStrings.public_profile.background}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.background_expl,
                done: this.state.pp.photo && this.state.pp.photo.length > 10,
                action: this.backgroundPicker.bind(this),
                imageUrl: this.state.pp.photo,
                deleteAction: this.deleteBackground
            },
            {
                name: `🏋️‍ ${resourceStrings.public_profile.teacher_info}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.teacher_info_expl,
                done: this.state.pp.teachers_done,
                action: this.showTeachers
            },
            {
                name: `🗒️ ${resourceStrings.public_profile.class_info}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.class_info_expl,
                done: this.state.pp.class_types_done,
                action: this.showClassTypes
            },
            {
                name: `🆓 ${this.state.pp.allow_free_reg ? resourceStrings.public_profile.registration_without_ticket_p : resourceStrings.public_profile.registration_without_ticket_n}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.click_here_to_switch + " " + resourceStrings.public_profile.registration_without_ticket_expl,
                done: true,
                action: this.updateAllowFreeReg.bind(this)
            },
            {
                name: `🤼 ${this.state.pp.allow_overbooking ? resourceStrings.public_profile.overbooking_is_allowed : resourceStrings.public_profile.overbooking_is_not_allowed}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.click_here_to_switch + " " + resourceStrings.public_profile.overbooking_expl,
                done: true,
                action: this.updateOverbooking.bind(this)
            },
            {
                name: `🤳 ${resourceStrings.public_profile.social_media_links}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.social_media_links_expl,
                done: true,
                action: this.editDescriptionAction.bind(this)
            },
            {
                name: `ℹ️ ${resourceStrings.public_profile.required_info}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.required_info_expl,
                done: false,
                action: this.showRequiredFieldsView.bind(this)
            },
            {
                name: `🗞️ ${resourceStrings.public_profile.news}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.news_expl,
                done: true,
                action: this.showAdEditor.bind(this)
            },
            {
                name: this.state.pp.show_book_all ? `📋️ ${resourceStrings.public_profile.multibooking_on_title}` : `📋️ ${resourceStrings.public_profile.multibooking_off_title}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.multibooking_expl,
                done: true,
                action: this.updateShowBookAll.bind(this)
            },
            {
                name: this.state.pp.is_new_user_allowed ? `👽 ${resourceStrings.public_profile.new_user_create_title_on}` : `👽 ${resourceStrings.public_profile.new_user_create_title_off}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.new_user_create_title_expl,
                done: true,
                action: this.updateNewUserAllowed.bind(this)
            },
            {
                name: this.state.pp.show_signups ? `🧑🏽‍🤝‍🧑🏻 ${resourceStrings.public_profile.show_signups_on}` : `🧑🏽‍🤝‍🧑🏻 ${resourceStrings.public_profile.show_signups_off}`,
                required: commonStrings.optional,
                description: resourceStrings.public_profile.show_signups_expl,
                done: true,
                action: this.updateShowSignups.bind(this)
            },


        ] : []

        console.log((data || []).length)

        return data.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.name === value.name
                ))
        )
    }

    deleteBackground(e) {
        e.preventDefault();
        e.stopPropagation();
        this.deleteBackgroundPhoto();
    }

    onChangeFile(event) {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        console.log(file);
        this.setState({file}); /// if you want to upload latter
        this.state.uploadingLogo ? this.uploadFile(file) : this.uploadBackgroundPhoto(file);
    }

    deleteLogo(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            isLoading: true,
        });
        const businessId = businessHelper.business().id;

        var deleteRef = storage.ref(`logos/${businessId}/user_logo_${this.state.business.id}`);

        // Delete the file
        deleteRef.delete().then(() => {
            this.updateBusinessLogo("");
        }).catch((error) => {
            this.handleNetworkError(error);
        });

    };

    updateBusinessLogo(url) {
        this.setState({isLoading: true});
        businessApiService.update({logo: url})
            .then(res => {
                this.setState({isLoading: false});
                this.getUser();
            })
            .catch((e) => {
                this.setState({isLoading: false});
                this.handleNetworkError(e)
            });
    }

    editDescriptionAction = () => {
        window.location.href = `/admin/user-profile`;
    };

    showTeachers = () => {
        window.location.href = `/admin/user-profile?sts=t`;
    };

    showClassTypes = () => {
        window.location.href = `/admin/user-profile?cts=t`;
    };

    showRequiredFieldsView = () => {
        this.setState({
            showReqFieldsModal: true
        });
    };

    showLoader(show = true) {
        this.setState({
            isLoading: show
        });
    }

    getPP() {
        this.showLoader();
        businessApiService.publicProfile()
            .then(res => {
                this.setState({
                    pp: res,
                });

                this.showLoader(false);
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    setPublic() {
        this.showLoader();
        businessApiService.update({public: !this.state.pp.public})
            .then(res => {
                this.showLoader(false);
                this.getPP();
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    updateAllowFreeReg() {
        this.showLoader();
        businessApiService.update({allow_free_reg: !this.state.pp.allow_free_reg})
            .then(res => {
                this.showLoader(false);
                this.getPP();
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    updateShowBookAll() {
        this.showLoader();
        businessApiService.update({show_book_all: "toggle"})
            .then(res => {
                this.showLoader(false);
                this.getPP();
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    updateNewUserAllowed() {
        this.showLoader();
        businessApiService.update({is_new_user_allowed: "toggle"})
            .then(() => {
                this.showLoader(false);
                this.getPP();
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    updateShowSignups() {
        this.showLoader();
        businessApiService.update({show_signups: "toggle"})
            .then(() => {
                this.showLoader(false);
                this.getPP();
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    updateOverbooking() {
        this.showLoader();
        businessApiService.update({allow_overbooking: !this.state.pp.allow_overbooking})
            .then(res => {
                this.showLoader(false);
                this.getPP();
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    // CANC POLICY

    showCPEditor(e) {
        if (e) e.preventDefault();
        this.setState({showCPModal: true})
    }

    toggleCPModal = state => {
        this.setState({
            showCPModal: !this.state.showCPModal
        });
    };

    toggleRIModal = state => {
        this.setState({
            showReqFieldsModal: !this.state.showReqFieldsModal
        });
    };

    closeCPView(e) {
        if (e) e.preventDefault();

        this.setState({
            showCPModal: false
        });

        this.getPP();
    }

    closeReqFieldsView(e) {
        if (e) {
            e.preventDefault();
        }
        ;

        this.setState({
            showReqFieldsModal: false
        });

        this.getPP();
    }

    renderCPModal() {
        const pp = this.state.pp;
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showCPModal}
                toggle={() => this.toggleCPModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.public_profile.canc_policy}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <CancPolicyView
                                test={true}
                                closeCPView={this.closeCPView}
                                pp={pp}
                                handleError={this.handleNetworkError}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    renderReqFieldsModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showReqFieldsModal == true}
                toggle={() => this.toggleRIModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.public_profile.required_info}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <RequiredFieldsView
                                closeReqFieldsView={this.closeReqFieldsView}
                                terms_link={this.state.pp.terms_link || null}
                                required_fields={this.state.pp.required_fields || []}
                                handleError={this.handleNetworkError}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    // NEWS EDITOR

    showAdEditor(e) {
        if (e) e.preventDefault();
        this.setState({showAdModal: true})
    }

    toggleAdModal = state => {
        this.setState({
            showAdModal: !this.state.showAdModal
        });
    };

    closeAdView(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({
            showAdModal: false
        });

        this.getPP();
    }

    renderAdModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showAdModal}
                toggle={() => this.toggleAdModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.public_profile.news}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <NewsView
                                closeAdView={() => this.closeAdView()}
                                ad={this.state.pp.ad}
                                ads={(this.state.pp.ads ?? [])}
                                handleError={this.handleNetworkError}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    getTicketTypes(requestedFor = "any") {
        this.setState({isLoading: true});

        TicketTypeApiService.index()
            .then(res => {
                this.setState({
                    ticketTypes: res,
                    isLoading: false,
                    showSModal: requestedFor === "s"
                });

            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    };

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    showStripeModal() {
        this.getTicketTypes("s")
    }

    sendVerificationLink() {
        this.showLoader();
        businessApiService.sendVerificationEmail()
            .then(res => {
                this.showLoader(false);
                alert(commonStrings.verification_sent)
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    goToStripe() {
        this.setState({goToS: true})
    }

    hideStripeModal() {
        this.setState({showSModal: false})
    }

    toggleStripeModal() {
        this.setState({showSModal: !this.state.showSModal})
    }

    disconnectStripe() {
        this.showLoader();
        this.hideStripeModal();

        businessApiService.disconnectStripe()
            .then(res => {
                this.showLoader(false);
                this.getPP();
            })
            .catch((e) => {
                this.props.handleNetworkError(e)
            });
    }

    readyToGoPublic() {
        return this.state.pp.verified && this.state.pp.description && this.state.pp.description.length > 10
            && this.state.pp.logo && this.state.pp.logo.length > 10 &&
            this.state.pp.address && this.state.pp.address.length > 5

    }

    copyDeeplink() {
        var copyText = document.getElementById("deeplink_input");
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.getSelection().empty()
    }

    clientAppBadgeDownloadLink() {
        switch (localeHelpers.currentLocale()) {
            case "es":
                return "https://firebasestorage.googleapis.com/v0/b/open-96133.appspot.com/o/open%2FOPEN%20Client%20Download%2FOPEN_Client_download_es.png?alt=media&token=31d74e00-7362-4332-9d84-1a07a97fdc99"
            case "ru":
                return "https://firebasestorage.googleapis.com/v0/b/open-96133.appspot.com/o/open%2FOPEN%20Client%20Download%2FOPEN_Client_download_ru.png?alt=media&token=318f0c73-af69-4bf3-bc5b-918fec298a5a"
            default:
                return "https://firebasestorage.googleapis.com/v0/b/open-96133.appspot.com/o/open%2FOPEN%20Client%20Download%2FOPEN_Client_download_eng.png?alt=media&token=aa63ca46-c642-4635-832a-d4d4662561cb"
        }
    }

    clientAppBadgeDownloadLinkDark() {
        switch (localeHelpers.currentLocale()) {
            case "es":
                return "https://firebasestorage.googleapis.com/v0/b/open-96133.appspot.com/o/open%2FOPEN%20Client%20Download%2FOPEN_Client_download_es_dark.png?alt=media&token=72ebf0b4-87ae-4793-bf54-6b17328ae4b4"
            case "ru":
                return "https://firebasestorage.googleapis.com/v0/b/open-96133.appspot.com/o/open%2FOPEN%20Client%20Download%2FOPEN_Client_download_ru_dark.png?alt=media&token=a24e7fc6-06ad-4010-9e6b-6282baa77dd0"
            default:
                return "https://firebasestorage.googleapis.com/v0/b/open-96133.appspot.com/o/open%2FOPEN%20Client%20Download%2FOPEN_Client_download_eng_dark.png?alt=media&token=d7e2752a-5a33-4090-a693-db512386e9ed"
        }
    }
}


PublicProfile.propTypes = propTypes;